import { IAppState } from '../../common/state';
import { ILabel } from '../../types/newbuildingHeader';

export function getLabels({ newbuildingInformation }: IAppState): ILabel[] | null {
  return newbuildingInformation?.labels || null;
}
